import React from 'react';
import { withTranslation } from "react-i18next";
import ErrorAlert from "./ErrorAlert";

const SelectInput = (props) => {
  const { t } = props;
  return (
    <div className={"form-group " + (props.error ? "not-valid" : "")}>
      <label className="input-label">{t(props.label)}</label>
      <select id={props.id} className="form-control" name={props.name} onChange={props.handleChange}>
        {Object.keys(props.options).map((option, index) => {
          return <option id={option} key={option} value={option}>{t(props.options[option])}</option>;
        })}
      </select>
      {props.hint && <i className="fa fa-question-circle" aria-hidden="true">{props.hint}</i>}
      {props.error &&
        <ErrorAlert error={props.error} />
      }
      {props.errorType && <div style={{ display: 'none' }} className={props.errorType}>{props.error}</div>}
    </div>
  )
}
export default withTranslation()(SelectInput);


